import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { usePresentVoiceText, useVoiceCopy } from '@/platform/voice/use-voice';

import { openPushSettings, type PushSettingsGuide } from './push-support';

type PushSettingsGuidePanelProps = {
  guide: PushSettingsGuide;
};

/** Persistent next step when the browser blocks its push service. */
export function PushSettingsGuidePanel({ guide }: PushSettingsGuidePanelProps) {
  const copy = useVoiceCopy();
  const present = usePresentVoiceText();

  async function copyAddress() {
    try {
      await navigator.clipboard.writeText(guide.settingsUrl);
      toast.success(copy('platform.push.copied'));
    } catch {
      toast.error(copy('platform.push.copy-failed'));
    }
  }

  return (
    <div className="space-y-3 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm">
      <p className="font-medium">{guide.browserLabel} erreicht den Push-Dienst nicht.</p>
      <p className="text-muted-foreground">
        {present(guide.action)} {copy('platform.push.copy-manual')}
      </p>
      <a href={guide.settingsUrl} className="block font-mono text-xs break-all underline">
        {guide.settingsUrl}
      </a>
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" onClick={() => openPushSettings(guide.settingsUrl)}>
          Einstellungen öffnen
        </Button>
        <Button type="button" size="sm" variant="outline" onClick={() => void copyAddress()}>
          Adresse kopieren
        </Button>
      </div>
    </div>
  );
}
